<mat-form-field appearance="outline" [ngClass]="{
  'w-100': true,
  'm-t-5': true,
  'mat-form-field-compact': size === 'compact',
  'mat-form-field-xs': size === 'xs'}">
    <!-- <mat-label>Enter a date range</mat-label> -->
    <mat-date-range-input [rangePicker]="picker">
        <input matStartDate placeholder="{{'datePicker.startDate' | translate}}"
            [formControl]="dateRange.get('startDate')" (dateChange)="getStartDate($event.value)">
        <input matEndDate placeholder="{{'datePicker.endDate' | translate}}" [formControl]="dateRange.get('endDate')"
            (dateChange)="getEndDate($event.value)">
    </mat-date-range-input>
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
</mat-form-field>